import script from "./FeedbackForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeedbackForm.vue?vue&type=script&lang=ts&setup=true"

import "./FeedbackForm.vue?vue&type=style&index=0&id=415c3b98&lang=sass"

const __exports__ = script;

export default __exports__